import React, { useState } from 'react';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Fab from '@mui/material/Fab';
import TextField from '@mui/material/TextField';

import AddIcon from '@mui/icons-material/Add';


const AddUser = (props) => {

	const [name, setName] = useState('');
	const [age, setAge] = useState('');
	const [head, setHead] = useState('Add User');

	// props.changeHead(head);

	const updateName = e => {
		setName(e.target.value);
	}

	const updateAge = e => {
		setAge(parseInt(e.target.value));
	}

	function addUser() {

		// validate

		// check if empty
		if(name.length == 0){

			setHead('pls enter name');

		}
		else if(age.length == 0){

			setHead('pls enter age');

		}
		// age is positive number 
		else if(typeof(parseInt(age)) != 'number'){

			setHead('age should be a number');
		
		}
		else if(age <= 0){

			setHead('age should be greater than 0');

		}
		// name should NOT be a number
		// else if(typeof(name) != 'string'){

		// 	setHead('name should be text !');

		// }
		else{

			//props.addNewUser(name + ' (' + age + ' years old) ');
			props.addNewUser({'name':name, 'age':age});

			// reset name and age
			setName('');
			setAge('');

			setHead('Add another User');
		}

	} // addUser ends

	return (
		<Card>
	        <CardContent className="home">

	          <Typography gutterBottom variant="h3" component="div">
	            {head}
	          </Typography>
	          	
	        <TextField value={name} onChange={updateName} label="Name" variant="outlined" />
      		<TextField value={age} onChange={updateAge} label="Age" variant="outlined" />
		    
		    <Fab onClick={addUser} color="success" aria-label="add">
          	<AddIcon />
        	</Fab>

	        </CardContent>
	    </Card>
	)
}

export default AddUser